import { Pipe, PipeTransform } from '@angular/core';
import { Users } from '../Model/Users.Model';

@Pipe({
  name: 'SettingsFilter',
  standalone: false
})
export class SettingFilterService implements PipeTransform {

  transform(users: Users[], searchTerm: string, field: string): Users[] {
    if (!users || !searchTerm) {
      return users;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();

    return users.filter(user =>
      this.matchesSearchTerm(user, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(user: Users, term: string): boolean {
    return (
      this.stringMatches(user.UserFistName, term) ||
      this.stringMatches(user.UserLastName, term) ||
      this.stringMatches(user.marketCompanyName, term) ||
      this.stringMatches(user.UserEmail, term)
    );
  }

  private stringMatches(value: string | null | undefined, term: string): boolean {
    return value?.toLowerCase().includes(term) ?? false;
  }
}
